import styles from './styles/Projects.module.css';

const Projects = () =>
{
    return (
        <div className={styles.container} >
            <ProjectItem title={'Exhibition Management System'}
                feature={(
                    <ul>
                        <li>Client: A Hong Kong's Statutory Body</li>
                        <li>Platform for Exhibitor to apply and manage exhibition</li>
                        <li>Administrator backend management</li>
                    </ul>
                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/exhibition.png`} className={styles.projectImage} />)}
                tags={['Next.Js', 'Node.js', 'Spring Boot', 'AWS']}
            />
            <ProjectItem title={'Event Management System'}
                feature={(
                    <ul>
                        <li>Manage guest list</li>
                        <li>Arrange seating plan by Drag and Drop</li>
                        <li>Batch send email/SMS invitation</li>
                        <li>Batch generate customized namecard</li>
                    </ul>
                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/EventManagementSystem.png`} className={styles.projectImage} />)}
                tags={['React', 'Node.js', 'IIS', 'MySQL']}
            />
            <ProjectItem title={'Elderly Center Management System'}
                feature={(
                    <ul>
                        <li>Manage Resident Expenditure</li>
                        <li>Handle resident payment (Auto-Debit)</li>
                        <li>Generate invoice/monthly report (PDF/Excel)</li>
                    </ul>
                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/ElderlyCenterManagement.png`} className={styles.projectImage} />)}
                tags={['React', 'Node.js', 'IIS']}
            />
            <ProjectItem title={'RFID Stick Check 點籤系統'}
                feature={(
                    <ul>
                        <li>Stick checking system, check if there are any missing/duplicated sticks</li>
                        <li>Realtime reading stick's RFID tags </li>
                    </ul>
                )}
                image={(
                    <img alt="" 
                        src={`${process.env.PUBLIC_URL}/image/Stick_Check.png`} className={styles.projectImage}
                        onClick={() => window.open(`${process.env.PUBLIC_URL}/image/Stick_Check.png`, '_blank')}
                        style={{ cursor: 'pointer', border: '1px solid #E5E7EB', width: '30%' }}
                    />)}

                tags={['C#', '.NET', 'RFID']}
            />
            <ProjectItem title={'Stick Enquiry 籤文查閱系統'}
                feature={(
                    <ul>
                        <li>Stick enquiry system for Kiosk (to general pubilc)</li>
                        <li>Integration with thermo printer to print out stick paper directly</li>
                    </ul>
                )}
                image={(
                    <img alt=""  src={`${process.env.PUBLIC_URL}/image/StickEnquiry.png`} className={styles.projectImage}
                        onClick={() => window.open(`${process.env.PUBLIC_URL}/image/StickEnquiry.png`, '_blank')}
                        style={{ cursor: 'pointer' }}
                    />)}

                tags={['C#', '.NET', 'Windows Form']}
            />
            <ProjectItem title={'SSY Medical Card 嗇色園醫療卡'}
                feature={(
                    <>
                        <ul>
                            <li>Medical e-Card mobile application on iOS and Android</li>
                            <li>Dynamic QR Code verification</li>
                            <li>SMS code login</li>
                            <li>Search doctor list by specialty/district/name</li>
                        </ul>
                        <span>
                            <a href="https://play.google.com/store/apps/details?id=com.siksikyuen.SSYMedicalCard&pcampaignid=web_share" target="_blank" rel="noreferrer">
                                <img alt=""  src={`${process.env.PUBLIC_URL}/image/getItOnGooglePlay.png`} className={styles.downloadAppImage} />
                            </a>
                            <a href="https://apps.apple.com/hk/app/%E5%97%87%E8%89%B2%E5%9C%92%E9%86%AB%E7%99%82%E5%8D%A1/id6736383358" target="_blank" rel="noreferrer">
                                <img alt=""  src={`${process.env.PUBLIC_URL}/image/downloadOnTheAppStore.png`} className={styles.downloadAppImage} />
                            </a>
                        </span>
                    </>
                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/SSYMedicalCard.png`} className={styles.projectImage} />)}
                tags={['React Native', 'Expo', 'Node.js', 'MySQL']}
            />
            <ProjectItem title={'IT Ticket System'}
                feature={(
                    <ul>
                        <li>Allow submittion of support ticket</li>
                        <li>Two level approval path</li>
                        <li>Email Notification/Email Approval</li>
                        <li>Graph report</li>
                    </ul>
                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/ItSupportTicket.png`} className={styles.projectImage} />)}
                tags={['React', 'Node.js', 'IIS', 'MySQL', 'Azure']}
            />
            <ProjectItem title={'Engineering Ticket System'}
                feature={(
                    <ul>
                        <li>Allow submittion of repair ticket</li>
                        <li>Two level approval path</li>
                        <li>Email Notification/Email Approval</li>
                        <li>Graph report</li>
                    </ul>
                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/EngineeringTicket.png`} className={styles.projectImage} />)}
                tags={['PHP', 'IIS', 'MySQL', 'Azure']} 
            />

            <ProjectItem title={'Fast Track 快速查詢巴士、地鐵、渡輪到站時間及班次(Personal Project)'}
                feature={(
                    <>
                        <ul>
                            <li>⚡ Quick Search: Search multiple routes at once for the nearest stops, displaying arrival times.</li>
                            <li>🛰️ Nearby Routes: Show bus arrival times for all nearby stops.</li>
                            <li>🚅 MTR: Display nearby MTR stations and the arrival times of the next trains.</li>
                            <li>⛴️ Ferries: Show nearby ferries and the departure times of the next ferries.</li>
                            <li>📑 Bookmarks: Save your frequently used stops.</li>
                        </ul>
                        <span>
                            <a href="https://play.google.com/store/apps/details?id=com.adorablecatdev.FastTrack&hl=en" target="_blank" rel="noreferrer">
                                <img alt=""  src={`${process.env.PUBLIC_URL}/image/getItOnGooglePlay.png`} className={styles.downloadAppImage} />
                            </a>
                        </span>
                    </>

                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/fastTrack.png`} className={styles.projectImage} />)}
                tags={['React Native', 'Node.js', 'Google Play']}
            />

            <ProjectItem title={'RTHK Archive (Personal Open Source Project)'}
                feature={(
                    <>
                        <ul>
                            <li>Download RTHK archive</li>
                            <li>Bookmark favourite program</li>
                            <li>Responsive, mobile friendly</li>
                        </ul>
                        <span>
                            <a href="https://rthk-archive.vercel.app/" target="_blank" rel="noreferrer">
                                <img alt=""  src={`${process.env.PUBLIC_URL}/image/RthkArchiveBtn.png`} className={styles.downloadAppImage} />
                            </a>
                            <a href="https://github.com/adorablecatdev/next_rthk_archive" target="_blank" rel="noreferrer">
                                <img alt=""  src={`${process.env.PUBLIC_URL}/image/GitHubBtn.png`} className={styles.downloadAppImage} />
                            </a>
                        </span>
                    </>

                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/RthkArchive.png`} className={styles.projectImage} />)}
                tags={['React', 'Next.js', 'Vercel']}
            />

            <ProjectItem title={'Check ETA 香港巴士到站查詢 (Personal Open Source Project)'}
                feature={(
                    <>
                        <ul>
                            <li>Display multiple route's ETA of closest stop</li>
                            <li>Support KMB/CTB/MTR</li>
                            <li>Bookmark bus stop</li>
                            <li>Map View</li>
                            <li>Desktop/Mobile compatible</li>
                        </ul>
                        <span>
                            <a href="https://checketa.vercel.app/" target="_blank" rel="noreferrer">
                                <img alt=""  src={`${process.env.PUBLIC_URL}/image/checkEtaBtn.png`} className={styles.downloadAppImage} />
                            </a>
                            <a href="https://github.com/adorablecatdev/react_check_eta.git" target="_blank" rel="noreferrer">
                                <img alt=""  src={`${process.env.PUBLIC_URL}/image/GitHubBtn.png`} className={styles.downloadAppImage} />
                            </a>
                        </span>
                    </>

                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/checkEta.png`} className={styles.projectImage} />)}
                tags={['React', 'Node.js', 'Vercel', 'Goverment API']}
            />

            <ProjectItem title={'咪錶地圖 - 查詢空置車位 (Personal Open Source Project)'}
                feature={(
                    <>
                        <ul>
                            <li>Check availability of parking meter at ease</li>
                            <li>Bookmark favourite parking meters</li>
                            <li>Map View</li>
                            <li>Desktop/Mobile compatible</li>
                        </ul>
                        <span>
                            <a href="https://parking-meters.vercel.app/tc/map" target="_blank" rel="noreferrer">
                                <img alt=""  src={`${process.env.PUBLIC_URL}/image/parkingMeterBtn.png`} className={styles.downloadAppImage} />
                            </a>
                        </span>
                    </>

                )}
                image={(<img alt=""  src={`${process.env.PUBLIC_URL}/image/parkingMeter.png`} className={styles.projectImage} />)}
                tags={['React', 'Node.js', 'Vercel', 'Goverment API']}
            />
        </div>
    )
}

export default Projects;

const ProjectItem = ({ title, feature, image, tags }) =>
{
    return (
        <div className={styles.projectItem}>
            <div className={styles.horizontalContainer}>
                <div className={styles.titleAndFeatureContainer}>
                    <div className={styles.title}>
                        {title}
                    </div>
                    <div className={styles.feature}>
                        {feature}
                    </div>
                </div>
                {image}
            </div>
            <div className={styles.tagsContainer}>
                {tags && tags.map((item, index) =>
                    <div className={styles.tag} key={index}>
                        {item}
                    </div>
                )}
            </div>
        </div>
    )
}